import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import IDeal, { IDealsPayload } from '@/creditflowresearch/domain/vo/IDeal';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import useDeals, { IDealsCollection } from './useDeals';

interface IUseAbsDealsProps {
  deals: IDealsCollection<IDeal, IDealsPayload>,
  fetch?: (payload: IDealsPayload) => Promise<IDealsCollection<IDeal, IDealsPayload>>,
  additionalFilters?: IDealsPayload,
}

const useAbsDeals = ({ deals, fetch, additionalFilters }: IUseAbsDealsProps) => {
  const { selectedTab } = useProductsContext();
  const isActive = selectedTab?.productIds?.includes(AbsProduct.PRODUCT_ID) ?? true;

  return useDeals({
    deals,
    fetch,
    additionalFilters,
    isActive,
  });
};

export default useAbsDeals;
